
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"12","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"hcuya","d":"M1661.993 1026.376l-2.037 9.376c-.048.221-.319.321-.51.188l-2.78-1.932a.476.476 0 00-.56.015l-1.542 1.203c-.179.14-.448.062-.517-.149l-1.07-3.294-2.765-.988a.308.308 0 01-.003-.584l11.348-4.19c.24-.089.488.113.436.355zm-2.776 1.648l-5.377 3.197a.515.515 0 00-.236.588l.58 1.971c.042.14.252.126.272-.018l.151-1.082a.878.878 0 01.285-.531l4.438-3.982c.083-.074-.017-.2-.113-.143z"}})]),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#hcuya","transform":"translate(-1650 -1026)"}})])
          )
        }
      }
    